import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { duration, easing } from "../../../design-system/tokens/transitions";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[3]};
  min-width: 0;
`;
export const Heading = styled.strong`
  ${typographyMixin("caption", 2)}
  color: ${rawColors.text.highEmphasis};
`;
export const Frame = styled.iframe<{ $height: string }>`
  display: block;
  width: 100%;
  height: ${({ $height }) => $height};
  border: 1px solid ${rawColors.grey[200]};
  border-radius: 0.75rem;
  background: ${rawColors.structural.white};
  box-sizing: border-box;
  animation: livePreviewFadeIn ${duration.normal} ${easing.smooth};
  @keyframes livePreviewFadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;
export const Empty = styled.div<{ $height: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${({ $height }) => $height};
  padding: ${spacing[4]};
  border: 1px dashed ${rawColors.grey[200]};
  border-radius: 0.75rem;
  background: ${rawColors.grey[50]};
  color: ${rawColors.text.lowEmphasis};
  text-align: center;
  box-sizing: border-box;
  ${typographyMixin("caption", 3)}
`;
